import { baseServerUrl } from "./apiConsts";

import { mockQuests } from "../MockData";
import { simpleRequest } from "./apiHelpers";

export const getAllQuests = async () => {
    return simpleRequest('get', `${baseServerUrl}/quests/all`, mockQuests);
};